import { Col, Row } from "react-bootstrap";
import KPICards from "./components/KPICards";
import AnalyticsCharts from "./components/AnalyticsCharts";
import DashboardWidgets from "./components/DashboardWidgets";
import QuickActions from "./components/QuickActions";
// @ts-ignore
import "./ModernAdminDashboard.css";

const ModernAdminDashboard = () => {
  return (
    <div className="modern-dashboard">
      {/* KPI Cards Row */}
      <Row className="g-2 mb-2">
        <Col xs={12}>
          <KPICards />
        </Col>
      </Row>

      {/* Analytics Charts Row */}
      <Row className="g-2 mb-2">
        <Col lg={8}>
          <AnalyticsCharts />
        </Col>
        <Col lg={4}>
          <DashboardWidgets />
        </Col>
      </Row>

      {/* Quick Actions Row */}
      <Row className="g-2">
        <Col xs={12}>
          <QuickActions />
        </Col>
      </Row>
    </div>
  );
};

export default ModernAdminDashboard;
